const checkoutData = {
  customerId: "",
  selectedFreightTerms: "",
  selectedCarriers: 0,
  DeLAddressDrop: "",
  DelCountry: "",
  DelContactName: "",
  DelCustomerName: "",
  DelPostalCode: "",
  DelAddress3: "",
  DelAddress2: "",
  DelAddress4: "",
  DelAddress1: "",
  retailerPurchaseOrderNo: "",
  VendorNotes: "",
  custPoNumber: "",
  orderLineInstructions: "",
  PrinterNotes: "",
  samplingAndPackagingCode: "",
  shippingMark: "",
  shippingInstruction: "",
  SpecialInstruction: "",
  DefaultDelivery: "",
  shipToID: 0,
  DeliveryAddress: {
    contact_name: "",
    delivery_customer_name: "",
    delivery_email: "",
    delivery_address1: "",
    delivery_address2: "",
    delivery_address3: "",
    delivery_address4: "",
    delivery_city: "",
    delivery_country: "",
    delivery_country_code: "",
    delivery_post_code: "",
    shipToID: 0,
  },
};
export default checkoutData;
